import { useEffect, useState } from "react";
import { Link, NavLink, Outlet, useLocation } from "react-router-dom";
import SiteFooter from "./SiteFooter";
import WhatsAppFloatButton from "../WhatsAppFloatButton";
import { Constants } from "../../constants/constants";
import "./MarketingLayout.css";

const NAV_ITEMS = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/pricing", label: "Pricing" },
];

/**
 * Public marketing shell: sticky header + page outlet + footer.
 * Wraps only the public pages — the product app keeps its own layouts.
 */
const MarketingLayout = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const { pathname } = useLocation();

  // Close the mobile menu and return to the top on every navigation.
  useEffect(() => {
    setMenuOpen(false);
    window.scrollTo(0, 0);
  }, [pathname]);

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    `marketing-header__link${isActive ? " marketing-header__link--active" : ""}`;

  return (
    <div className="marketing">
      <header className="marketing-header">
        <div className="marketing-header__inner">
          <Link to="/" className="marketing-header__brand">
            <span className="marketing-header__logo" aria-hidden="true">
              C
            </span>
            <span className="marketing-header__name">Carely IT</span>
          </Link>

          <nav className="marketing-header__nav" aria-label="Primary">
            {NAV_ITEMS.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={linkClass}
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="marketing-header__actions">
            <Link to="/login" className="marketing-header__login">
              Login
            </Link>
            <button
              type="button"
              className={`marketing-header__burger${menuOpen ? " marketing-header__burger--open" : ""}`}
              aria-expanded={menuOpen}
              aria-controls="marketing-mobile-nav"
              aria-label="Toggle navigation menu"
              onClick={() => setMenuOpen((open) => !open)}
            >
              <span />
              <span />
              <span />
            </button>
          </div>
        </div>

        {menuOpen && (
          <nav
            id="marketing-mobile-nav"
            className="marketing-header__mobile"
            aria-label="Mobile"
          >
            {NAV_ITEMS.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={linkClass}
              >
                {item.label}
              </NavLink>
            ))}
            <Link
              to="/login"
              className="marketing-header__login marketing-header__login--mobile"
            >
              Login
            </Link>
          </nav>
        )}
      </header>

      <main className="marketing-main">
        <Outlet />
      </main>

      <WhatsAppFloatButton phone={Constants.SUPPORT_PHONE} />

      <SiteFooter />
    </div>
  );
};

export default MarketingLayout;
